import { SidebarGroup, SidebarMenu, SidebarGroupContent, SidebarGroupLabel } from '@talentmesh/ui/components/sidebar';
import { Sparkle } from 'lucide-react';
import { generatePath } from 'react-router';
import LineMenuItem from './LineMenuItem';
import { useRecruitmentId } from '@/Hooks';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

interface AISearchNavGroupProps {
    isActive: boolean;
}

const AISearchNavGroup = ({ isActive }: AISearchNavGroupProps) => {
    const assessmentId = useRecruitmentId();
    const companyId = useCompanyId();

    return (
        <SidebarGroup className="p-0" data-cy="aiSearchList">
            <SidebarGroupLabel className="text-muted-foreground text-xs tracking-wide uppercase">
                <span className="mx-2">{UIStrings.AISearch}</span>
            </SidebarGroupLabel>
            <SidebarGroupContent>
                <SidebarMenu>
                    <LineMenuItem
                        isActive={isActive}
                        to={generatePath(RoutePath.AgenticAiSearch, { assessmentId, companyId })}
                    >
                        <Sparkle />
                        {UIStrings.AgenticSearch}
                    </LineMenuItem>
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
};

export default AISearchNavGroup;
